import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';

import sprite from '../../../../img/sprites.svg';

const CoursesSection = ({ title, initiallyOpen, children }) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen);
  const contentId = useId();

  return (
    <section className={`courses-section ${isOpen ? 'is-open' : ''}`.trim()}>
      <button
        type="button"
        className="courses-section__head"
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={() => setIsOpen((value) => !value)}
      >
        <span className="courses-section__title">{title}</span>
        <svg className="courses-section__arrow" aria-hidden="true"><use href={`${sprite}#chevrone-down`}></use></svg>
      </button>

      <div className="courses-section__body" id={contentId} inert={isOpen ? undefined : ''}>
        <div className="courses-section__inner">
          <div className="courses-grid">{children}</div>
        </div>
      </div>
    </section>
  );
};

CoursesSection.propTypes = {
  title: PropTypes.string.isRequired,
  initiallyOpen: PropTypes.bool,
  children: PropTypes.node,
};

CoursesSection.defaultProps = {
  initiallyOpen: true,
  children: null,
};

export default CoursesSection;
